import { registerQuery } from 'data-fetching-client';
import I18n from 'I18n';
import getLangLocale from 'I18n/utils/getLangLocale';
import { getAllFeaturesRpc } from '../../__generated__/chirp/com/hubspot/feature/store/rpc/FeatureStoreAppRpc';
import { rpcClient } from '../client';
export const getFeature = async ({
  shortName
}) => {
  var _response$features;
  const i18nLangLocale =
  // @ts-expect-error dependency missing types
  I18n.loaded && I18n.locale ? getLangLocale() : `${Languages.EN}-us`;
  const response = await rpcClient.call(getAllFeaturesRpc, {
    request: {
      i18nLangLocale,
      shortNames: [shortName]
    }
  });
  return (_response$features = response.features) === null || _response$features === void 0 ? void 0 : _response$features[0];
};
export const FEATURE_STORE_FEATURE_QUERY = registerQuery({
  fieldName: 'featureStoreFeature',
  args: ['shortName'],
  fetcher: getFeature
});